import { push, pushToGA, pushToPixel } from "../services/sendEvent";
import { destructureEventLabel } from "../utils/helper";

export const fireLeadGeneratedEvent = (data: any) => {
	// Call push function with event-label "lead_generated" and required payload
	push({
		event_label: "lead_generated",
		event_datum: {
			field_information: data,
		},
	});

	// destru. and pass and seperate identity;
	const {
		brandName,
		contactNumber,
		email,
		hasGst,
		platform,
		numberOfOrders,
		categories,
		otherCategory,
	} = data;

	// Push to Google Analytics
	pushToGA({
		eventLabel: "lead_generated",
		brandName,
		contactNumber,
		email,
		hasGst,
		platform,
		numberOfOrders,
		categories,
		otherCategory,
	});

	pushToPixel({
		eventLabel: "submit_product_link",
	}, true);

	pushToPixel({
		eventLabel:  destructureEventLabel(data.fbEventLabel),
	}, true);

	pushToGA({
		eventLabel: "submit_product_link",
	})

	pushToGA({
		eventLabel: destructureEventLabel(data.fbEventLabel),
	})
};
